<div class="reviews-outer">
  <h2 class="trinidad-bold">Leave a public review.</h2>
  <p class="wizard-paragraph _12px">
    Provide your public review. Write a fair, honest review about your stay. Let other guests know about your experience
    during your stay so they know what to expect.
  </p>
  <form id="email-form" name="email-form" data-name="Email Form" [formGroup]="reviewForm" (ngSubmit)="submitReview()">
    <div class="w-form">
      <h3 class="trinidad-bold">Tell us about your experience with {{ (boondock$ | async)?.name | trim }}.</h3>
      <div class="response-details-inner">
        <label for="site-review" class="sr-only">Site Review</label>
        <textarea
          placeholder="Tell us about your stay..."
          rows="6"
          maxlength="5000"
          id="site-review"
          name="site-review"
          formControlName="review"
          data-name="site-review"
          class="w-input"
        ></textarea>
        <div
          class="w-form-fail"
          style="display: block"
          *ngIf="
            reviewForm.controls.review?.errors?.minlength ||
            reviewForm.controls.review?.errors?.maxlength ||
            (reviewForm.controls.review?.errors?.required && reviewForm.controls.review?.touched)
          "
        >
          <div>Please add your public review.</div>
        </div>
      </div>
    </div>
    <div class="button-wrapper" *ngIf="isCaretaker">
      <button type="submit" class="button trinidad center w-button">Next</button>
    </div>
    <div class="button-wrapper" *ngIf="!isCaretaker">
      <button type="button" class="button trinidad center w-button" (click)="onCompleteReview()">
        Complete Review
      </button>
      <button type="submit" class="button trinidad center w-button">Add Additional Info</button>
    </div>
  </form>
</div>
